const menuConfig = {
    dashboard: "/user-dashboard/",
    pageMgn: "/user-dashboard/pageMgn", 
    userMgn: "/user-dashboard/userMgn", 
    settings: "/user-dashboard/settings",  
    accessControl: "/user-dashboard/accessControl",
    orgChart: "/user-dashboard/orgChart",
    userOrgInfo: "/user-dashboard/userOrgInfo",
    appointmentParameters: "/user-dashboard/appointmentParameters",
    appointment: "/user-dashboard/appointment",
    processTypes: "/user-dashboard/processTypes",
    workflows: "/user-dashboard/workflows",
    leaveRequests: "/user-dashboard/leaveRequests",
    myTasks: "/user-dashboard/myTasks",
    myRequests: "/user-dashboard/myRequests",
    leaveSettings: "/user-dashboard/leaveSettings",
    bonusTypes: "/user-dashboard/bonusTypes",
    bonusRequests: "/user-dashboard/bonusRequests",
    userDocumentType: "/user-dashboard/userDocumentType",
    announcements: "/user-dashboard/announcements",
    desktopManagement: "/user-dashboard/desktopManagement",
    messageCategories: "/user-dashboard/messageCategories", 
    userOrgInfo: "/user-dashboard/userOrgInfo",
    messages: "/user-dashboard/messages",
    workflowAssignments: "/user-dashboard/workflowAssignments",
    tickets: "/user-dashboard/tickets",
    ticketTypes: "/user-dashboard/ticketTypes",
    tasks: "/user-dashboard/tasks",
    auditorAssignments: "/user-dashboard/auditorAssignments"
};

const staticMenuConfig = {
    pageMgn: "/admin-dashboard/pageMgn", 
    userMgn: "/admin-dashboard/userMgn", 
    settings: "/admin-dashboard/settings",  
    accessControl: "/admin-dashboard/accessControl",
    orgChart: "/admin-dashboard/orgChart",
    userOrgInfo: "/admin-dashboard/userOrgInfo",
    appointmentParameters: "/admin-dashboard/appointmentParameters",
    appointment: "/admin-dashboard/appointment",
    processTypes: "/admin-dashboard/processTypes",
    workflows: "/admin-dashboard/workflows",
    leaveRequests: "/admin-dashboard/leaveRequests",
    myTasks: "/admin-dashboard/myTasks",
    myRequests: "/admin-dashboard/myRequests",
    leaveSettings: "/admin-dashboard/leaveSettings",
    bonusTypes: "/admin-dashboard/bonusTypes",
    bonusRequests: "/admin-dashboard/bonusRequests",
    userDocumentType: "/admin-dashboard/userDocumentType",
    announcements: "/admin-dashboard/announcements",
    desktopManagement: "/admin-dashboard/desktopManagement",
    messageCategories: "/admin-dashboard/messageCategories",
    messages: "/admin-dashboard/messages",
    workflowAssignments: "/admin-dashboard/workflowAssignments",
    tickets: "/admin-dashboard/tickets",
    ticketTypes: "/admin-dashboard/ticketTypes",
    tasks: "/admin-dashboard/tasks",
    auditorAssignments: "/admin-dashboard/auditorAssignments"
};

export { menuConfig, staticMenuConfig };
